<template>
  <div class="container pb-40" style="margin-top: 7px;">
    <TopGradientBlockLayout class="mb-12">
      <template v-slot:top>
        <ReportsFilters/>
      </template>
      <ReportIncomeDynamics v-if="filters.type === 'income'"/>
      <ReportExpenseDynamics v-else/>
    </TopGradientBlockLayout>
    <div class="grid grid-cols-12 col-gap-12">
      <div class="col-span-7 relative">
        <ReportIncomeTransactions v-if="filters.type === 'income'"/>
        <ReportExpenseTransactions v-else/>
      </div>
      <div class="col-span-5">
        <ReportIncomeStructureCharts v-if="filters.type === 'income'"/>
        <ReportExpenseStructureChart v-else/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import ReportsFilters from "@/components/cabinet/Money/Reports/ReportsFilters";
import ReportIncomeDynamics from "@/components/cabinet/Money/Reports/ReportIncome/ReportIncomeDynamics";
import ReportExpenseDynamics from "@/components/cabinet/Money/Reports/ReportExpense/ReportExpenseDynamics";
import ReportIncomeTransactions from "@/components/cabinet/Money/Reports/ReportIncome/ReportIncomeTransactions";
import ReportExpenseTransactions from "@/components/cabinet/Money/Reports/ReportExpense/ReportExpenseTransactions";
import ReportIncomeStructureCharts from "@/components/cabinet/Money/Reports/ReportIncome/ReportIncomeStructureCharts";
import ReportExpenseStructureChart from "@/components/cabinet/Money/Reports/ReportExpense/ReportExpenseStructureChart";

export default {
  name: "TheReports",
  components: {
    ReportExpenseStructureChart,
    ReportExpenseTransactions,
    ReportIncomeStructureCharts,
    ReportIncomeTransactions,
    TopGradientBlockLayout,
    ReportsFilters,
    ReportExpenseDynamics,
    ReportIncomeDynamics,
  },
  data() {
    return {
      type: 'income'
    }
  },
  computed: {
    ...mapState('reports/report_filters', ['filters'])
  },
  async created() {
    this.$store.dispatch('space/incomes/getIncomes');
    this.$store.dispatch('space/expenses/getExpenses');
    this.$store.dispatch('space/expenses/getExpenseGroups');
  }
}
</script>

<style>
.chartjs-tooltip {
  opacity: 1;
  position: absolute;
  background: rgba(0, 0, 0, .7);
  color: white;
  border-radius: 3px;
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
  pointer-events: none;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  white-space: nowrap;
}

.chartjs-tooltip-key {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 6px;
}
</style>